import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormControl } from '@angular/forms';
import { SharedService } from '../../services/shared.service';
import { ShippingService } from '../../services/shipping.service';
import { Observable, of } from 'rxjs';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { startWith, map, debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { DatePipe } from '@angular/common'
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { YmdSpacedNativeDateAdapter, YMD_SPACED_DATE_FORMATS } from '../../material/ymd-spaced-native-date-adapter';
import Swal from 'sweetalert2';


@Component({
  selector: 'app-receiving',
  templateUrl: './receiving.component.html',
  styleUrls: ['./receiving.component.css'],
  providers: [
    { provide: DateAdapter, useClass: YmdSpacedNativeDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: YMD_SPACED_DATE_FORMATS }
  ]
})
export class ShippingReceivingComponent implements OnInit {
  dateEnd: any;
  dateStart: any;
  shippingStatusId: number = 2;
  shippingTypeId: number = 0;
  shippingId: number = 0;

  shippings: any[] = [];
  showErrorMessage: boolean = false;
  errorMessage: string;


  constructor(private sharedService: SharedService,
    private shippingService: ShippingService,
    private router: Router,
    private spinnerService: Ng4LoadingSpinnerService,
    private datepipe: DatePipe) { }

  @ViewChild('closebutton', { static: false }) closebutton;

  ngOnInit() {
    this.sharedService.reloadUserPrivileges();
    this.loadDate();
    this.loadShippings();
  }

  public onFiltersChange() {
    this.showErrorMessage = false;
    var resultFieldsValidation = this.validateDate();
    if (resultFieldsValidation.length == 0) {
      this.loadShippings();
    }
    else {
      this.loadErrorMessage(resultFieldsValidation.join(" "));
    }
  }

  loadDate() {
    this.dateEnd = new Date();
    this.dateStart = new Date();
    this.dateStart.setDate(this.dateStart.getDate() - 14);
  }

  onActionFacilityUnit() {
    this.onFiltersChange();
  }

  validateDate(): string[] {
    var errors: string[] = [];
    if (this.dateEnd < this.dateStart)
      errors.push("The End Date must be greater then Start Date!")

    return errors;
  }

  clearErrorMessage() {
    this.showErrorMessage = false;
    this.errorMessage = "";
  }

  loadErrorMessage(message: any) {
    this.showErrorMessage = true;
    this.errorMessage = message.toString();
    window.scroll(0, 0);
  }

  private loadShippings() {
    if (typeof this.sharedService.pharmacyId === 'undefined'
      || typeof this.sharedService.facilityId === 'undefined'
      || typeof this.sharedService.facilityUnitId === 'undefined'
      || typeof this.shippingStatusId === 'undefined'
      || typeof this.shippingTypeId === 'undefined') {
      return;
    }

    var startDateText = this.datepipe.transform(this.dateStart, 'yyyy-MM-dd');
    var endDateText = this.datepipe.transform(this.dateEnd, 'yyyy-MM-dd');

    this.shippingService.getShippings(this.sharedService.pharmacyId, this.sharedService.facilityId, this.sharedService.facilityUnitId, this.shippingStatusId, this.shippingTypeId, startDateText, endDateText).subscribe(data => {
      this.shippings = data;
    });
  }

  view(id) {
    this.router.navigate(['receiving/view/' + id]);
  }

  exportToPdf(id) {
    this.router.navigate([]).then(result => { window.open('report/Shipping/' + id + '/' + 'Shipping', '_blank'); });
  }

  /** True when list row is Received (status id or title from API). */
  isReceivedStatus(shipping: any): boolean {
    if (shipping && shipping.shippingStatusId === 4) return true;
    return this.getShippingStatusClass(shipping.shippingStatus) === 'received';
  }

  /**
   * Confirms then reverts a Received shipment to Shipped (server enforces Received-only).
   * UI label: "Revert to Shipped" — undo receiving / reopen for delivery confirmation.
   */
  confirmRevertReceivedToShipped(shipping: any): void {
    var priv = this.sharedService.userPrivilegeVo;
    if (priv == null || !priv.hasReceivingRevertToShippedAccess) {
      return;
    }
    Swal.fire({
      icon: 'warning',
      title: 'Revert to Shipped?',
      html: 'This will <strong>force</strong> the status from <strong>Received</strong> to <strong>Shipped</strong>. ' +
        'Receiving metadata and line received flags will be cleared. Use only when correcting a mistake.',
      showCancelButton: true,
      confirmButtonText: 'Yes, revert',
      cancelButtonText: 'Cancel',
      confirmButtonColor: '#d89098',
      cancelButtonColor: '#6c757d',
      focusCancel: true
    }).then((result) => {
      if (!result.isConfirmed) return;
      this.shippingService.revertReceivedToShipped(shipping.id, this.sharedService.getUserId()).subscribe((resultVo) => {
        if (resultVo && resultVo.success) {
          this.sharedService.showTempSuccessMessage();
          this.loadShippings();
          window.scroll(0, 0);
        } else {
          this.loadErrorMessage((resultVo && resultVo.message) ? resultVo.message : 'Revert failed.');
        }
      });
    });
  }

  /** Returns a CSS-safe class suffix for status badge color (draft, shipped, deleted, received, draft-receive). */
  getShippingStatusClass(status: string): string {
    if (!status) return 'default';
    var s = status.toLowerCase().trim();
    if (s === 'draft') return 'draft';
    if (s === 'shipped') return 'shipped';
    if (s === 'deleted') return 'deleted';
    if (s === 'received') return 'received';
    if (s === 'draft receive' || s === 'draftreceive') return 'draft-receive';
    return 'default';
  }
}
